import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { TypePolicyService } from 'src/app/service/typePolicy.service';
import { PolicyService } from 'src/app/service/policy.service';
import { TypePolicyModel } from 'src/app/model/typePolicy.model';
import { ProcessService } from 'src/app/service/process.service';
import { PolicyModel } from 'src/app/model/policy.model';
import { UserModel } from 'src/app/model/user.model';
import { AuthenticationService } from 'src/app/service/auth.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AttributeModel } from '../../dynamic/model/attribute.model';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-type-process',
  templateUrl: './type-process.component.html',
  styleUrls: ['./type-process.component.scss']
})
export class TypeProcessComponent implements OnInit {

  typePolices: TypePolicyModel[];
  typePolicyId: string;
  policies: any[];
  userName: UserModel = new UserModel;
  validatedPolicyAccess : boolean = false;


  constructor(
    private processService: ProcessService,
    private typePolicyService: TypePolicyService,
    private policyService: PolicyService,
    private authService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    // swal.showLoading();
    this.spinner.show();
    this.loadForm();
    this.userName = this.authService.getUser();
  }

  loadForm() {
    this.getTypePolicies();
  }

  getTypePolicies() {
    if(!this.typePolices){
      this.typePolicyService.list().subscribe(typePolices =>{
        this.typePolices = [];
        typePolices.filter(type => this.hasPermission(type)).forEach(typePolicy =>{
          var opt = typePolicy.options
            .find(attr => attr.key.toLocaleLowerCase() == 'type');

          if(opt && opt.value.toLowerCase() == 'typepolicy'){
            this.typePolices.push(typePolicy);
            let attributeModel: AttributeModel = new AttributeModel();
            attributeModel.key = typePolicy.name;
            attributeModel.value = typePolicy.name;
            typePolicy.attributes.push(attributeModel);
          }
        });

        // swal.close();
        this.spinner.hide();
      });
    }
    return [];
  }

  private hasPermission(typePolicy: TypePolicyModel): boolean {
    let restriction = typePolicy.attributes.find(attr => 
        attr.key.toLowerCase() == "user" && attr.type.toLowerCase() == "restriction")

    if(restriction) {
        let roles = restriction.attributes
          .filter(attr => attr.key.toLowerCase() == "role")
          .map(attr => attr.value)

        if(roles.length == 0) {
            return true;
        }

        let currentUser = this.authService.getUser()

        if(currentUser && currentUser.roles) {
            return roles.some(role => currentUser.roles.includes(role))
        } else {
            return false;
        }
    }

    return true;
  }

  getPolicy(typePolicyId: string) : any {
    this.policies = null;
    // swal.showLoading();
    this.spinner.show();

    this.policyService.listByTypePolicy(typePolicyId).subscribe(policies => {
      this.policies = policies;
      // swal.close();
      this.spinner.hide();
      return this.policies;
    });
  }

  selectPolicy(id: string) {
    if (id != null) {
      let chosenPolicy = this.policies.find(p => p.id == id)

      if(!chosenPolicy) {
        return
      }

      if(chosenPolicy.allowPublicAccess) {
        window.open(this.getFormsUrl(chosenPolicy), '_blank');
      } else {
        this.processService.newProcess(id); 
      }
    }
  }

  getFormsUrl(policy): string {
    let url = "https://forms";

    if(environment.name.toLowerCase() == "sandbox") {
      url += `.sandbox`
    }

    if(environment.name.toLowerCase() == "develop") {
      url += `.dev`
    }

    url += `.buildflex.io/atendimento/${policy.accessCode}`

    return url
  }

  validateAccessPolicy(policy : PolicyModel): boolean {
    let validated :boolean = false;
    let editar = policy.myStep != undefined ?  policy.myStep.attributes.find(element => element.key == 'Editar') : null;
    if(editar != null){
    let role = editar.attributes.find(element => element.key == 'Role');
    if(role != undefined){
      role.attributes.forEach(policyRoles =>{
        if(policyRoles != undefined){
          this.userName.roles.forEach(userRoles => {
            if(userRoles != undefined && userRoles == policyRoles.key && policyRoles.value == 'true')
              validated = true;
          });
        }
      });
      }else{
        validated = true;
      }
    }else{
      validated = true;
    }
    return validated;
  }

}
